module.exports = __webpack_public_path__ + "static/tlb-78c8456e0384f7caf9821986faac916b.png";